import {
  Avatar,
  Box,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography
} from '@mui/material'
import Info from '@mui/icons-material/Info'
import React from 'react'
import { ButtonDownloadTemplate } from './ButtonDownloadTemplate'
import {
  templateEditMassiveProcessPositions,
  templateCreateMassiveProcessPositions
} from '../../const/templatesFileName'

interface DialogInfoProps {
  editMode: boolean
}

export const DialogInfo: React.FC<DialogInfoProps> = ({ editMode }) => {
  return (
    <Grid item xs={12} style={{ padding: '0px' }}>
      <List style={{ width: '100%' }}>
        <ListItem alignItems='flex-start'>
          <ListItemAvatar>
            <Avatar>
              <Info />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography variant='h6' component='h6' gutterBottom>
                IMPORTANTE: Esta acción <b>no</b> es posible de revertir.
              </Typography>
            }
            secondary={
              <React.Fragment>
                <Box>
                  <Typography component='ol' style={{ listStyle: 'square' }}>
                    <Typography variant='subtitle1' component='li' gutterBottom>
                      Si existe un <b>error</b> en el archivo, toda la carga se{' '}
                      <b>invalidará</b>, favor revise el estado de esta en el
                      menú procesos.
                    </Typography>
                    <Typography variant='subtitle1' component='li' gutterBottom>
                      Sólo se actualizarán posiciones de <b>venta</b> o{' '}
                      <b>reposición</b>.
                    </Typography>
                    <Typography variant='subtitle1' component='li' gutterBottom>
                      Se recomienda que la operación no tenga{' '}
                      <b>rutas de picking</b> en proceso o sin concluir.
                    </Typography>
                    <Typography variant='subtitle1' component='li' gutterBottom>
                      Puede descargar una <b>plantilla</b> desde el link que se
                      encuentra disponible a continuación.
                      <br />
                      <ButtonDownloadTemplate
                        nameFileTemplate={
                          editMode
                            ? templateEditMassiveProcessPositions
                            : templateCreateMassiveProcessPositions
                        }
                        textButtonParam={
                          editMode
                            ? 'Descargar Plantilla Modificación'
                            : 'Descargar Plantilla Creación'
                        }
                      ></ButtonDownloadTemplate>
                    </Typography>
                  </Typography>
                </Box>
              </React.Fragment>
            }
          />
        </ListItem>
      </List>
    </Grid>
  )
}
